import React, { useMemo } from 'react';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
import useLanguages from '../../../data/hooks/useLanguages';
import Error from '../../utils/Error';
import useResetOnDeps from './hooks/useResetOnDeps';
import SelectBoxFilter from './SelectBoxFilter';
import styles from './LanguagesMultiSelector.scss';
const LanguagesMultiSelector = ({ isFullSizeButton = false, className, title, filterOptions, isResetEnabled = false, isDisabled = false, filter, isSingleSelect = false, hasLiveSearch = true, ...props }) => {
    const t = useT();
    const { loading, error, languages } = useLanguages();
    const _title = useMemo(() => (loading ? t('loading...') : title || t('Languages')), [t, loading, title]);
    const _options = useMemo(() => (filterOptions ? filterOptions(languages, filter) : languages), [filter, filterOptions, languages]);
    useResetOnDeps(_options, props.onChange, [], isResetEnabled);
    if (error) {
        return <Error error={error}/>;
    }
    return isSingleSelect ? (
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    <SelectBoxFilter disabled={isDisabled} hasBottomMargin={false} hasLiveSearch={hasLiveSearch} isInTable={false} options={_options} searchInputClassName={styles.searchInputClassName} searchInputWidthClassName={styles.searchInputWidthClassName} title={_title} {...props}/>) : (<MultiselectFilter liveSearch classNames={className} disabled={loading || isDisabled} isFullSizeButton={isFullSizeButton} options={_options} title={_title} {...props}/>);
};
export default LanguagesMultiSelector;
